import React from 'react'
import Slider from 'react-slick'
import SwipeableClinicCard from '../ClinicCard/SwipeableClinicCard.jsx'
import './ResultsSwipeableList.scss'
import './slick-carousel/slick.css'
import './slick-carousel/slick-theme.css'

const ResultsSwipeableList = ({
  lexicon,

  sortedAndFilteredClinics,
  cardDisplayState,
  updateCardDisplayState,
  sliderRef,
  // selectedClinicIndex, setSelectedClinicIndex,
  // setFocusedPinIndex,
  // isMobileMapOpen,
  // filterGestationalAge,
  // locationState,

  // age,
  // allAbortionLaws,
  children = null, // this is only need for testing
}) => {
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: false, // this means wrapping around
    focusOnSelect: false, // DO NOT TURN THIS ON, it will mess up animation
    speed: 1200,
    // adaptiveHeight: true,
    centerMode: true,
    centerPadding: '5%',
    beforeChange: (current, next) => {
      if (cardDisplayState.isMobileMapOpen) {
        updateCardDisplayState({
          selectedClinicIndex: next,
          focusedPinIndex: next,
        })

        // console.log('before change', 'current', current, 'next', next, 'selectedClinicIndex', cardDisplayState.selectedClinicIndex)
      }
    },
    slidesToScroll: 1,
    slidesToShow: 1,
  }

  return (
    <div className="ResultsSwipeableList">
      <Slider ref={sliderRef} {...sliderSettings}>
        {sortedAndFilteredClinics.map((clinic, i) => (
          <div className="clinic-card-spacer" key={clinic.id}>
            <SwipeableClinicCard
              lexicon={lexicon.subset('ClinicCard')}
              clinic={clinic}
              clinicNum={i + 1}
              isSelected={i === parseInt(cardDisplayState.selectedClinicIndex)}
            />
          </div>
        ))}
      </Slider>

      {children}
    </div>
  )
}

export default ResultsSwipeableList
